import _classCallCheck from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/pubskape-frontend/node_modules/@babel/runtime/helpers/esm/inherits";

/** This Component can be used to wrap a functional component in order to generate a random ID
 * Example of how to use this component
 *
 * const Component = ({id}: {id: string}) => (
 *  <GenerateId>{randomId => (
 *     <div id={id || randomId}>
 *       div with random ID
 *     </div>
 *   )}
 *  </GenerateId>
 *  );
 */
import * as React from 'react';
var currentId = 0;
export var GenerateId =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GenerateId, _React$Component);

  function GenerateId() {
    var _this;

    _classCallCheck(this, GenerateId);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GenerateId).apply(this, arguments));
    _this.id = "".concat(_this.props.prefix).concat(currentId++);
    return _this;
  }

  _createClass(GenerateId, [{
    key: "render",
    value: function render() {
      return this.props.children(this.id);
    }
  }]);

  return GenerateId;
}(React.Component);
GenerateId.displayName = 'GenerateId';
GenerateId.defaultProps = {
  prefix: 'pf-random-id-'
};